module.exports = __webpack_public_path__ + "img/ta-hj-leftTitle02.374168e7.png";